import PageContainer from './PayPastDueRentPaymentPage.container';

export default PageContainer;
